<div class="empty-list-content">
  <div class="empty-list-image-container">
    <img class="image-empty-list" src="{{ imagePath }}" />
  </div>
  <div class="empty-list-text-container">
    <h2 class="text-empty-list-head">{{ titleText }}</h2>
    <p class="text-empty-list-article">{{ articleText }}</p>
  </div>
</div>
